<template>
    <div class="news" style="vertical-align: middle;text-align: center">
        <div style=' margin: 0px auto;background: rgba(0, 0, 0, 0) url("web/bk/bk1.png") repeat scroll 0% 0% / 100%;'>
            <img src="../../assets/images/about/banner.png" style="height: 505px; width: 1300px;display: block;margin: 0px auto;">
        </div>
        <!-- ============= 信息更新列表内容 ============= -->
        <div class="news-table"   style="display: inline-block;width:900px;text-align: left" v-html="data">
            
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
                data: '',
            }
        },
        mounted:function(){
            this.getHtml();
        },
        methods: {
            getHtml () { // 获取信息列表
                let _this = this;
                //获取GET的值
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/qu_excel?type=2',
                }).then((response) =>{
                    this.data = response.data
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
        }
  };
</script>

<style >
   tbody tr:nth-child(odd) {
      background-color:#fff;
    }
    tbody tr:nth-child(even) {
      background-color:#CACBFF99;
    }

    .old_free{
        border-collapse: collapse;
        border-spacing: 0;
        margin: 0 auto; 
    }
    .old_free th{
        background-color:#6c98ff;
        color:white;
    }
    .old_free td,.old_free th{
        border-bottom: 1px solid #ebeef5;
    }
    .old_free div{
        margin: 2px 10px;
    }
    
    .table-content {
        margin-top: 25px;
        font-size: 18px;
        cursor: pointer;
    }
    
    .table_left{
        font-size: 22px;
    }
    
    
    .wtq_hover:hover{color: #6190cd;}
</style>



// WEBPACK FOOTER //
// src/pages/qu/excel.vue